import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function approvalPhoto(campaignId, photoId, approval) {
  return new Promise((resolve, reject) => {
    authToken(null)
      .then((token) => {
        const config = {
          method: 'post',
          url: cfac22('API_HOST_V2') + '/campaignPolls/approvalPhoto',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Full-Url': window.location.href,
          },
          data: {
            campaignId: campaignId,
            photoId: photoId,
            approval: approval,
          },
        };

        axios(config)
          .then((result) => {
            resolve(result.data);
          })
          .catch((error) => {
            return reject(error.data.response);
          });
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}
